import ReportDonutView from "./ReportDonutView";
import ReportSemiDonutView from "./ReportSemiDonutView";
import ReportDueMeter from "./ReportDueMeter";
import ReportOdometer from "./ReportOdometer";

export { ReportDonutView, ReportSemiDonutView, ReportDueMeter, ReportOdometer};



// WEBPACK FOOTER //
// ./src/features/dashboard/components/reports/index.js